import { render } from "./MyDatePicker.vue?vue&type=template&id=b555378e"
import script from "./MyDatePicker.vue?vue&type=script&lang=js"
export * from "./MyDatePicker.vue?vue&type=script&lang=js"

import "../../../node_modules/v-calendar/dist/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__